"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BioCard = void 0;
exports.renderBioSection = renderBioSection;
var _litHtml = require("lit-html");
require("solid-ui/components/actions/button");
require("./BioSection.css");
var _texts = require("../../texts");
var _sectionCardHelpers = require("../shared/sectionCardHelpers");
var _BioEditDialog = require("./BioEditDialog");
var _profileIcons = require("../../icons-svg/profileIcons");
function renderBio(bioData) {
  if (!bioData) return (0, _litHtml.html)``;
  const bioDescriptionId = 'bio-description';
  return (0, _litHtml.html)`
      ${bioData.description ? (0, _litHtml.html)`
        <div class="bio-card__description-wrap">
          <p class="bio-card__description-text" id=${bioDescriptionId}>${bioData.description}</p>
          <solid-ui-button
            type="button"
            variant="secondary"
            size="sm"
            label="...more"
            class="bio-card__description-toggle"
            aria-controls=${bioDescriptionId}
            aria-expanded="false"
            hidden
            @click=${_sectionCardHelpers.toggleDescription}
          >
            ...more
          </solid-ui-button>
        </div>
      ` : ''}
  `;
}
function hasBioContent(bioData) {
  return Boolean((bioData?.description || '').trim());
}
const BioCard = bioData => {
  return (0, _litHtml.html)`
    <article class="bio-card" aria-label="Bio" data-testid="bio-card">
      <section class="bio-card__section">
        ${renderBio(bioData)}
      </section>
    </article>
  `;
};
exports.BioCard = BioCard;
function renderBioSectionContent(store, subject, bioData, viewerMode, onSaved) {
  const bio = BioCard(bioData);
  const bioDetails = bioData;
  const isOwner = viewerMode === 'owner';
  return (0, _litHtml.html)`
    <header class="profile__section-header profile-section-collapsible__header">
      <h2 id="bio-heading" tabindex="-1">${_texts.bioHeadingText}</h2>
      ${isOwner ? (0, _litHtml.html)`
        <solid-ui-button
          type="button"
          variant="secondary"
          size="sm"
          class="profile__action-button profile-action-text bio-section__edit-button profile-section-collapsible__edit-button"
          aria-label="Edit bio details"
          @click=${event => {
    return (0, _BioEditDialog.createBioEditDialog)(event, store, subject, bioDetails, viewerMode, onSaved);
  }}
        >
          <span class="profile-section-collapsible__edit-label profile__action-icon">${_profileIcons.editIcon} Edit</span>
          <span class="profile-section-collapsible__edit-icon profile__action-icon" aria-hidden="true">${_profileIcons.editIcon}</span>
        </solid-ui-button>
      ` : (0, _litHtml.html)``}
    </header>
    <div class="profile-section-collapsible__content">
      ${bio}
    </div>
  `;
}
function renderBioSectionDefault(store, subject, bioData, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="bio-heading" 
      data-profile-section="bio"
      class="profile__section" 
      role="region"
      tabindex="-1"
    >
      ${renderBioSectionContent(store, subject, bioData, viewerMode, onSaved)}
    </section>
  `;
}
function renderOwnerEmptyBioContent(store, subject, bioData, viewerMode, onSaved) {
  const bioDetails = bioData;
  return (0, _litHtml.html)`
    <div class="profile__empty-state-content" role="group" aria-label="Empty bio section">
      <h2 id="bio-heading" tabindex="-1">${_texts.bioHeadingText}</h2>
      <p class="profile__empty-state-message">
        You haven't added any professional experience yet. Adding work history can boost your Bio.
      </p>
    </div>
    <solid-ui-button
      type="button"
      variant="secondary"
      size="sm"
      class="profile__action-button--empty"
      aria-label="Add bio details"
      @click=${event => {
    return (0, _BioEditDialog.createBioEditDialog)(event, store, subject, bioDetails, viewerMode, onSaved);
  }}
    >
      <span class="profile__action-icon" aria-hidden="true">${_profileIcons.plusDarkIcon} Add Bio</span>
    </solid-ui-button>

  `;
}
function renderOwnerEmptyBioSection(store, subject, bioData, viewerMode, onSaved) {
  return (0, _litHtml.html)`
    <section 
      aria-labelledby="bio-heading" 
      data-profile-section="bio"
      class="profile__section--empty profile__section--empty-main bio-section--empty" 
      role="region"
      tabindex="-1"
    >
      ${renderOwnerEmptyBioContent(store, subject, bioData, viewerMode, onSaved)}
    </section>
  `;
}
function renderBioSection(store, subject, bioData, viewerMode, onSaved) {
  (0, _sectionCardHelpers.scheduleDescriptionOverflowCheck)();
  const hasBio = hasBioContent(bioData);
  const showOwnerEmptyBio = !hasBio && viewerMode === 'owner';
  const showSection = true;
  return showSection ? (0, _litHtml.html)`
    ${showOwnerEmptyBio ? renderOwnerEmptyBioSection(store, subject, bioData, viewerMode, onSaved) : renderBioSectionDefault(store, subject, bioData, viewerMode, onSaved)}
  ` : '';
}